export const parseSchoolId = (schoolId: number | undefined) => {
  if (schoolId === undefined) {
    return -1;
  }
  return schoolId;
};



// WEBPACK FOOTER //
// ./src/features/director/pages/seasons/seasonsPage/utils/parseSchoolId/parseSchoolId.ts